const ARROW_KEYS_UP_DOWN = "ArrowKeysUpDown"
const ARROW_KEYS_UP_DOWN__SWITCH_SONGS = "SwitchSongs"
const ARROW_KEYS_UP_DOWN__SCROLL_SONG = "ScrollSong"

const defaults = {
	[ARROW_KEYS_UP_DOWN]: ARROW_KEYS_UP_DOWN__SWITCH_SONGS
}

const ControlService = {
	getSettings(type) {
		let value = localStorage.getItem(type)
		if (!value) value = defaults[type]
		return value
	},
	setSettings(type, value) {
		localStorage.setItem(type, value)
	}
}

export {
	ControlService,
	ARROW_KEYS_UP_DOWN,
	ARROW_KEYS_UP_DOWN__SWITCH_SONGS,
	ARROW_KEYS_UP_DOWN__SCROLL_SONG
};
